import { Module } from 'vuex-module-decorators';
import store from '@/store';
import FilterModule from '@/store/filter';

@Module({ dynamic: true, store, name: 'citiesFilter', namespaced: true })
export default class CitiesFilter extends FilterModule {
    constructor(module: CitiesFilter) {
        super(module);
    }
}
